/* eslint-disable */
import { notification } from "antd";
import endpoints from "configs/endpoints";
import { t1 } from "../i18n";
import Requester from "./network/http/Request";

const messagesByResponseCode = {
  E_LOGIN_FAILED: "Invalid email or password",
  E_SESSION_EXPIRED: "Your session is expired",
};

export const fetchData = async (url, params = {}, configsInput, showProgress, showAlert, returnFullDataIfNoStatus) => {
  const responseData = await Requester.get(url, params, configsInput, showProgress, showAlert);
  if (!responseData) { 
    return null;
  }

  if (responseData.status < 400 && responseData.data) {
    return responseData.data;
  }
  if (returnFullDataIfNoStatus) {
    return responseData;
  }
  return null;
};

export const isMobile = () => window.innerWidth <= 800;

export const showResponseMessage = (responseData) => {
  if (!responseData || !responseData._message) {
    return;
  }
  /**
   * if server return the message, we will alert to the end user
   */
  if (responseData._responseType && notification[responseData._responseType]) {
    notification[responseData._responseType]({
      message: responseData._responseType,
      description: responseData._message,
      // duration: 5,
      // closeIcon: () => ""
    });
    return;
  }

  notification.warning({
    message: t1("generate warning message!..."),
    description: responseData._message,
  });
};

export const showResponseMessageError = (response = {}) => {
  const responseData = response.data || {};
  // return;
  if (responseData.status === 401 && responseData.code === "E_JWT_TOKEN_EXPIRED") {
    return;
  }
  if (responseData.errors && responseData.errors.length) {
    const error = responseData.errors[0];
    notification.warning({
      message: error.field,
      description: error.message,
      // duration: 5,
      // closeIcon: () => ""
    });
  } else if (responseData.code && messagesByResponseCode[responseData.code]) {
    notification.warning({
      message: "Message",
      description: messagesByResponseCode[responseData.code],
      // duration: 5,
      // closeIcon: () => ""
    });
  } else if (responseData.message) {
    notification.warning({
      message: "Message",
      description: responseData.message,
      // duration: 5,
      // closeIcon: () => ""
    });
  } else if (responseData.error) {
    notification.error({
      message: "Something went wrong!",
      description: responseData.error,
      // duration: 5,
      // closeIcon: () => ""
    });
  } else {
    notification.warning({
      message: "Error",
      description: responseData.msg || "Unknown error",
      // duration: 5,
      // closeIcon: () => ""
    });
  }
};

export const fetchNode = async (node, params, nodeAction = "find", returnDocumentsOnly = true) => {
  const response = await Requester.get(endpoints.node.find, { ...params, node }, { headers: { nodeAction } });
  if (!returnDocumentsOnly) {
    return response;
  }
  if (!response || !response._success || !response._result) {
    return [];
  }
  return response._result.documents || [];
};

export const updateNode = async (node, params, nodeAction = "update", returnDocumentsOnly = true) => {
  const response = await Requester.post(endpoints.node.update, { ...params, node });
  if (!returnDocumentsOnly) {
    return response;
  }
  if (!response || !response._success || !response._result) {
    return [];
  }
  return response._result.documents || [];
};

export const getParams = (props) => {
  const { match } = props;
  if (match && match.params) {
    return match.params;
  }
  return {};
};

export const getParamsFromSearchString = (searchString) => {
  const params = new URLSearchParams(searchString);
  if (params) {
    return params;
  }
  return {};
};
